import {CLOSE_DRAWER, OPEN_DRAWER, ADD_POST, GET_POSTS, PLAY_ANIMATION} from './actionTypes';

export const toggleAnimation = (visible) => {
    return {
        type: PLAY_ANIMATION,
        payload: {
            visible: !visible,
        }
    }
}

export const openDrawer = (content) => {
    return {
        type: OPEN_DRAWER,
        payload: {
            open: true,
            content
        }
    }
}


export const closeDrawer = (content) => {
    return {
        type: CLOSE_DRAWER,
        payload: {
            open: false,
            content: content
        }
    }
}

export const createPost = (content, category, date) => {
    return {
        type: ADD_POST,
        payload: {
            date,
            category,
            content
        }
    }
}

export const getPosts = (filter) => {
    return {
        type: GET_POSTS,
        payload: {
            filter
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/index.js